export enum CheckboxStates {
	Checked = "Checked",
	Indeterminate = "Indeterminate",
	Empty = "Empty",
}
